export const escapeRegExp = (string: string | undefined): string => {
  if (!string) {
    return ''
  }

  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
